export default __webpack_public_path__ + "static/media/file.05423873.svg";